module.exports = __webpack_public_path__ + "media/dorobek/assets/images/login/logo-text-white-4df070ba9f99e476628bce0be7f8da9b.svg";